/* globals document */

// import { getTenantId } from 'common/helpers/apiHelper';

import {
  GET_SETTING_OBJECT_REQUESTING,
  GET_SETTING_SUCCESS
} from './constants';

const getInitialSettings = () => {
  const nextJSScript = document.getElementById('__NEXT_DATA__');

  if (!nextJSScript?.innerHTML) {
    return null;
  }

  try {
    const nextJSProps = JSON.parse(nextJSScript.innerHTML);

    if (!nextJSProps?.props?.pageProps?.settings) {
      return null;
    }

    return nextJSProps.props.pageProps.settings;
  } catch {
    return null;
  }
};

const INITIAL_STATE = {
  data: getInitialSettings(),
  isObjectFetching: false
};

const reducer = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case GET_SETTING_OBJECT_REQUESTING: {
      return {
        ...state,
        isObjectFetching: true
      };
    }
    case GET_SETTING_SUCCESS: {
      const data = action.payload;
      // if (getTenantId() === 'development') {
      //   data.paystack = {
      //     apiKey: 'pk_test_0face1c3aa0bfcd96e0d199c80fc2dcd1d983981'
      //   };
      //   data.currency = 'ZAR';
      // }
      // if (getTenantId() === 'development') {
      //   data.compliance.requiresAutoRenewalConsent = true;
      // }
      return {
        data,
        isObjectFetching: false
      };
    }
    default:
      return state;
  }
};

export default reducer;
